import React from 'react';
import StopSelectContainer from '../../../../ui/shared/containers/StopSelectContainer';

const StopSelect = ({ id, routeId = null, purpose = null, type = 'all', className, placeholder, input, meta, onChange = () => {}}) =>
    <StopSelectContainer
        id={id}
        routeId={routeId}
        purpose={purpose}
        firstInput={input.value ? input.value.firstInput : null}
        secondInput={input.value ? input.value.secondInput : null}
        onBlur={() => input.onBlur(input.value)}
        onChange={(stop)=>{
            onChange(stop);
            input.onChange(stop)
        }}
        className={className}
    />
;

export default StopSelect;
